import { motion } from "framer-motion";

const STEPS = [
  { no: "I", title: "Konsultasi & Survei", body: "Diskusi visi, survei lahan, dan analisis kelayakan — gratis dan tanpa komitmen." },
  { no: "II", title: "Konsep & Visual 3D", body: "Denah, fasad, dan render fotorealistik direvisi hingga Anda jatuh cinta." },
  { no: "III", title: "Struktur & Pembangunan", body: "Pembangunan terjadwal dengan laporan progres mingguan dan QC berlapis." },
  { no: "IV", title: "Serah Terima & Garansi", body: "Handover terdokumentasi lengkap dengan garansi struktur 10 tahun tertulis." },
];

export const Process = () => (
  <section id="proses" data-testid="process-section" className="relative py-28 lg:py-36 bg-slatewarm border-y border-white/5 overflow-hidden">
    <div className="absolute inset-0 architect-grid opacity-40" />
    <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="font-mono-arch text-[11px] tracking-[0.35em] uppercase text-brass mb-5"
      >
        Blueprint Proses
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.1 }}
        className="font-serif-lux font-light text-3xl sm:text-4xl lg:text-5xl text-bone tracking-tight leading-[1.12] max-w-2xl"
      >
        Dari sketsa pertama hingga kunci di tangan Anda.
      </motion.h2>

      <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.no}
            data-testid={`process-step-${i + 1}`}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: i * 0.12 }}
            className="group bg-slatewarm hover:bg-surface transition-colors duration-500 p-8"
          >
            <p className="font-serif-lux italic text-4xl brass-text-gradient">{s.no}.</p>
            <div className="w-8 h-px bg-brass/50 my-6 group-hover:w-14 transition-all duration-500" />
            <h3 className="font-serif-lux text-xl text-bone">{s.title}</h3>
            <p className="text-sm text-ash font-light leading-relaxed mt-3">{s.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
